export type ResourceManagementConfigQueryKey = [
  'resource-management',
  'config',
];

export const getResourceManagementConfigQueryKey =
  (): ResourceManagementConfigQueryKey => ['resource-management', 'config'];
